export const Types = {
    GET_AWB_SUCCESS: "GET_AWB_SUCCESS",
    GET_AWB_FAILURE: "GET_AWB_FAILURE",
    GET_AWB_REQUEST: "GET_AWB_REQUEST",
  };
  
export const getAWBRequest = (loading = true) => ({ 
     type: Types.GET_AWB_REQUEST,
     payload: { loading }
});
  
  export const getAWBFailure = (items) => ({
    type: Types.GET_AWB_FAILURE,
    payload: { items },
  });
  
  export const getAWBSuccess = ( key, value) => ({
    type: Types.GET_AWB_SUCCESS,
    payload: { key, value },
  });